


































































import {
  computed,
  defineComponent, onMounted, reactive, Ref, ref, watch,
} from '@vue/composition-api';
import _ from 'lodash';
import { useRouter } from '@ideavivat/vivat-2';

import {
  getJobs,
  getSubJobs,
} from '@/api/index';
import receiveSubJob from '@/table/Store/receive-sub-job';
import confirmPickupSubJob from '@/table/Store/confirm-pickup-sub-job';
import { Job } from '@/types/job';
import { paginatorInfo, PaginatorInfo } from '@/types';

import CommonModalWithStoreReceiveStatus from '@/components/Store/CommonModalWithStoreReceiveStatus.vue';

const presetFilters = [
  {
    name: '0',
    display: 'รายการชิ้นส่วน ที่ผ่าน QC แล้ว',
    table: receiveSubJob,
    column: 'receive_amount',
    action: 'รับชิ้นส่วน',
    filter: {
      filterQCStoreAmount: 0,
      filterExceptStatus: 'CANCELLED',
    },
  },
  {
    name: '1',
    display: 'รายการชิ้นส่วนที่รับเข้าคลังแล้ว',
    table: confirmPickupSubJob,
    column: 'pickup_amount',
    action: 'ยืนยันการส่งชิ้นส่วน',
    filter: {
      filterStoreAmount: 0,
      orFilterAssemblyPendingAmount: 0,
      filterExceptStatus: 'CANCELLED',
    },
  },
];

const StoreQC = defineComponent({
  components: {
    CommonModalWithStoreReceiveStatus,
  },
  setup() {
    const { route, router } = useRouter();
    const refetchQuery = ref(false);
    const selectedJobs: Ref<any> = ref([]);
    const filter = reactive({
      code: '',
      pendingSearch: false,
    });
    const selectedFilterIndex: Ref<number | string> = ref('0');
    const computedSubJobTableVariables = computed(() => {
      const vars = {
        filterBomIds: selectedJobs.value?.map((elm: any) => elm.id) || undefined,
        ...presetFilters[selectedFilterIndex.value as number].filter,
      };

      return vars;
    });

    const jobs: Ref<Job[]> = ref([]);
    const jobPage = ref(1);
    const jobPaginatorInfo: Ref<PaginatorInfo> = ref(paginatorInfo);

    async function getJobsData() {
      const { data: result, ...pagination } = (await getJobs({
        searchString: filter.code !== '' ? filter.code : undefined,
        orderBy: [{ field: 'created_at', order: 'DESC' }],
        filterStatus: 'PENDING',
        'page[number]': jobPage.value,
        'page[size]': 15,
      })).data;

      const camelPagination = {
        from: pagination.from,
        to: pagination.to,
        lastPage: pagination.last_page,
        total: pagination.total,
        currentPage: pagination.current_page,
        perPage: pagination.per_page,
      };

      if (filter.pendingSearch || jobPaginatorInfo.value.currentPage === camelPagination.currentPage) {
        jobs.value = [];
        jobs.value = result;
        jobPage.value = 1;
        filter.pendingSearch = false;
      } else jobs.value = [...jobs.value, ...result];
      jobPaginatorInfo.value = camelPagination;
    }
    const pendingSearchAction = _.debounce(async () => {
      await getJobsData();
    }, 500);

    onMounted(async () => {
      await getJobsData();
    });

    function scrollJobsAreaHandler(visible: any) {
      if (jobPaginatorInfo.value.lastPage > jobPage.value && visible) {
        jobPage.value += 1;
      }
    }
    watch(() => jobPage.value, async (newVal, oldVal) => {
      if (newVal !== oldVal) await getJobsData();
    });

    watch(() => route.value.params.bomId, async (newVal, oldVal) => {
      if (newVal !== oldVal) refetchQuery.value = true;
    });

    const pendingSearch = _.debounce(() => { refetchQuery.value = true; }, 250);
    const totalItems = ref(0);
    const tableData = ref([]);
    // Use with select box
    const selectedItemId: Ref<number[]> = ref([]);
    const selectedItem: Ref<any[]> = ref([]);
    function handlerFetchData(queryData: any) {
      const { data, from, to } = queryData;
      totalItems.value = (to - from) + 1;
      tableData.value = data;
    }
    function tabChangeHandler(tabName: string) {
      selectedFilterIndex.value = tabName;
      selectedItemId.value = [];
      selectedItem.value = [];
      pendingSearch();
    }
    function handleSelectAllItem($event: any[]) {
      if (selectedItemId.value.length === tableData.value.length) {
        selectedItemId.value = [];
        selectedItem.value = [];
      } else {
        selectedItemId.value = $event;
        selectedItem.value = tableData.value;
      }
    }
    function selectItem(id: number | string, item: any) {
      const hitIndex = selectedItemId.value.indexOf(parseInt(id as string, 10));
      if (selectedItemId.value.indexOf(parseInt(id as string, 10)) > -1) {
        selectedItemId.value.splice(hitIndex, 1);
        selectedItem.value.splice(hitIndex, 1);
      } else {
        selectedItemId.value.push(parseInt(id as string, 10));
        selectedItem.value.push(item);
      }
    }
    const selectedAll = computed(() => selectedItemId.value.length === totalItems.value);

    return {
      presetFilters,
      selectedFilterIndex,
      selectItem,
      selectedItemId,
      selectedItem,
      handlerFetchData,
      tabChangeHandler,
      handleSelectAllItem,
      selectedAll,

      getJobs,
      getSubJobs,
      scrollJobsAreaHandler,
      filter,
      pendingSearchAction,
      computedSubJobTableVariables,

      selectedJobs,

      refetchQuery,
    };
  },
});

export default StoreQC;
